import styled from '@emotion/styled'

type FieldWrapperProps = {
    noLabel?: boolean
    noError?: boolean
    shown?: boolean
}

const getMinHeight = ({ noLabel, noError }: FieldWrapperProps) => {
    let height = 86
    if (noLabel) {
        height -= 24
    }
    if (noError) {
        height -= 20
    }
    return height
}

const FieldWrapper = styled.div<FieldWrapperProps>`
    width: 100%;
    min-height: ${(props: FieldWrapperProps) => getMinHeight(props)}px;
    display: ${({ shown = true }) => (shown ? 'block' : 'none')};
`

export { FieldWrapper }
